/** @jsxImportSource @emotion/react */

import React from 'react';
import { connect } from 'unistore/react';
import { css } from '@emotion/react';
import ReactMarkdown from 'react-markdown';

import SmallPulse from '../../components/Loader/smallPulse';
import { Button } from '@components';
import IfElse from '../../components/IfElse';
import YoutubeBtn from '../../components/Button/youtubeBtn';

import {
	requestIdleCb,
	Harpic,
	checkDocument,
	hasOwn,
	getAnimationEndEvent,
	getTransitionEndEvent,
} from '@utils/customLib';
import { sidebarActions } from '@utils/store/actions';
// import IfElse from '../IfElse';

const wh7Style = css`
	height: 7px;
	width: 7px;
`;

class BbUpdateHeader extends React.PureComponent {
	constructor(props) {
		super(props);
		this.bar = React.createRef();
	}

	componentDidMount() {
		setTimeout(() => {
			requestIdleCb(this.DragMeDownToHell);
		}, 3000);
	}

	DragMeDownToHell = () => {
		const bar = this.bar.current;

		if (checkDocument() && bar && hasOwn(window, 'requestAnimationFrame')) {
			requestAnimationFrame(() => {
				bar.style.display = '';
				const a = bar.getBoundingClientRect();
				bar.style.transform = `translateY(-${a.height}px)`;
				bar.style.display = 'none';
				bar.style.height = '0px';
				bar.style.willChange = 'height, transform';
				bar.style.display = '';
				if (getAnimationEndEvent) {
					bar.addEventListener(
						getAnimationEndEvent,
						this.removeInlineStyleOnShow
					);
				}
				setTimeout(() => {
					bar.style.height = `${a.height}px`;
					setTimeout(() => {
						bar.classList.add('slideInDown', 'u-animated');
					}, 250);
				}, 100);
			});
		}
	};

	LiftMeUpToHeaven = () => {
		const bar = this.bar.current;

		if (checkDocument() && bar && hasOwn(window, 'requestAnimationFrame')) {
			requestAnimationFrame(() => {
				const a = bar.getBoundingClientRect();
				bar.style.height = `${a.height}px`;
				bar.style.willChange = 'height, transform';
				bar.style.transform = 'translateY(0)';
				bar.style.transition =
					'height 0.3s ease-out, transform 0.3s ease-out';
				if (getTransitionEndEvent) {
					bar.addEventListener(
						getTransitionEndEvent,
						this.removeInlineStyleOnHide
					);
				}
				setTimeout(() => {
					bar.style.height = '0px';
					bar.style.transform = `translateY(-${a.height}px)`;
				}, 100);
			});
		}
	};

	removeInlineStyleOnHide = () => {
		const bar = this.bar.current;

		this.props.__setHeaderUpdatesLastRead();

		if (getTransitionEndEvent) {
			bar.removeEventListener(
				getTransitionEndEvent,
				this.removeInlineStyleOnHide
			);
		}
	};

	removeInlineStyleOnShow = () => {
		const bar = this.bar.current;

		bar.style.transform = '';
		bar.style.height = '';
		bar.style.willChange = '';
		bar.classList.remove('slideInDown', 'slideInUp', 'u-animated');
		if (getAnimationEndEvent) {
			bar.removeEventListener(
				getAnimationEndEvent,
				this.removeInlineStyleOnShow
			);
		}
	};

	renderHeader = () => {
		const {
			headerUpdates: { title, text, links },
		} = this.props;
		let link = '';
		let sanitizedLinkText = '';

		if (links && links.length > 0 && links[0].web) {
			link = links[0];

			sanitizedLinkText = link.text;
		}
		const sanitizedTitle = title;

		return (
			<div
				className="bb-updateheader__item flex justify-between xs:items-center py-4"
				key={title}
			>
				<div className="mr-8 flex items-start justify-start">
					<div>
						<SmallPulse
							className="bb__pulse-svg inline-block align-middle mr-4"
							css={wh7Style}
						/>
					</div>

					<div>
						{title && (
							<span className="font-bold mr-2 text-snowWhite">
								{sanitizedTitle}
							</span>
						)}
						<ReactMarkdown
							components={{
								p: props => <span {...props} />,
								a: ({ children, ...props }) => (
									<Button
										{...props}
										variant="outlinecolored"
										size="vtiny"
										target="_blank"
										rel="noreferrer noopener"
										className="mx-2 text-gray-600 hover:text-lavender"
										triangle="right"
									>
										<span className="text-lavender">
											{children}
										</span>
									</Button>
								),
							}}
						>
							{Harpic(text)}
						</ReactMarkdown>
					</div>
				</div>
				<div className="flex flex-col flex-wrap xs:flex-nowrap items-end justify-between xs:flex-row">
					<IfElse
						condition={link}
						then={
							<IfElse
								condition={link.type === 1}
								then={
									<Button
										href={link.web}
										target="_blank"
										rel="noreferrer noopener"
										size="vtiny"
										variant="outlinecolored"
										linkClass="mt-4 xs:mt-0 order-last xs:order-first"
										className="text-gray-600 hover:text-lavender whitespace-nowrap"
										triangle="right"
									>
										<span className="text-lavender">
											{sanitizedLinkText}
										</span>
									</Button>
								}
								else={
									<IfElse
										condition={link.type === 2}
										then={
											<YoutubeBtn
												triangle="right"
												size="tiny"
												btnProps={{
													variant: 'outlinecolored',
												}}
												videoId={link.video}
												modalText={sanitizedTitle}
												text={sanitizedLinkText}
												className="text-lavender mt-4 xs:mt-0 mr-2 order-last xs:order-first"
											/>
										}
										else={
											<Button
												href={`https://bitbns.com/trade/#${link.web}`}
												size="vtiny"
												variant="outlinecolored"
												linkClass="mt-4 xs:mt-0 order-last xs:order-first"
												className="text-gray-600 hover:text-lavender whitespace-nowrap"
												triangle="right"
											>
												<span className="text-lavender">
													{sanitizedLinkText}
												</span>
											</Button>
										}
									/>
								}
							/>
						}
					/>

					<Button
						variant="outlinecolored"
						title="close"
						className="text-2xl font-thin p-2 leading-x ml-4 text-gray-600 hover:text-lavender whitespace-nowrap order-0 xs:order-last"
						onClick={this.LiftMeUpToHeaven}
					>
						<span className="text-lavender">&times;</span>
					</Button>
				</div>
			</div>
		);
	};

	render() {
		const { isNotFlagged } = this.props;

		return (
			<div
				className={`bb-updateHeader text-sm ${
					(!isNotFlagged && 'bg-red-600') || ''
				}`}
				ref={this.bar}
				style={{
					display: 'none',
				}}
			>
				<div className="container">
					{isNotFlagged ? (
						this.renderHeader()
					) : (
						<div className="text-white flex justify-between items-center">
							<div className="my-4 mr-8 flex items-start justify-start">
								<div>
									<SmallPulse
										className="bb__pulse-svg inline-block align-middle mr-4"
										css={wh7Style}
									/>
								</div>

								<div>
									Due to unusual trading activity your
									FIAT/cryptocurrency balance has become
									negative. Corresponding amount of FIAT or
									cryptocurrency has been added to your
									account. You would need to ensure the
									balances in all your sections - all
									cryptocurrencies &gt;=0 and your FIAT wallet
									balance &gt; 0 for resuming withdrawal
									activity for cryptocurrencies and FIAT
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default connect('', sidebarActions)(BbUpdateHeader);
